import { createRouter } from "@tanstack/react-router";
import { routeTree } from "./routeTree.gen";

export const getRouter = () => {
  const router = createRouter({
    routeTree,
    // Single-page marketing site — skip scroll-restoration runtime work.
    scrollRestoration: false,
    defaultPreloadStaleTime: 0,
  });

  return router;
};
